import React, { Component } from 'react';
import QRCode from 'react-qr-code';
import { QRCode as QRCodeCanvas } from 'react-qrcode-logo';
import Barcode from 'react-barcode';
import { LABELTEMPLATES } from '../../variables/framesStatics';

const styles = {
    container: {
        width: '300px',
        height: '150px',
        padding: '10px',
        border: '1px solid #000',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '12px',
        gap: '10px',
    },
    text: {
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
};

class LabelTemplate extends Component {
    render() {
        const { templateId, code, text1, text2, title, scale, widthMM, heightMM, qrcode } = this.props;
        const template = LABELTEMPLATES[templateId];
        if (!template) {
            return <div>No template found!</div>;
        }

        return <div>{template.render(code, text1, text2, title, scale, widthMM, heightMM, qrcode)}</div>;
    }
}

export default LabelTemplate;
